import LIB from '../utility/Library'

export default class Common {
  constructor() {
    this.onResize()
    this.setAnimationDelay()
  }

  onResize() {
    if (LIB.isPc) return

    const handleResize = () => {
      const landscapeClass = 'is-landscape'

      if (window.innerWidth >= window.innerHeight) {
        document.body.classList.add(landscapeClass)
      } else {
        document.body.classList.remove(landscapeClass)
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)
  }

  setAnimationDelay() {
    const illustList = document.getElementsByClassName('anime-illust-list')
    const delays     = [0, 40, 40, 40, 10]

    for (let i = 0, iLength = illustList.length; i < iLength; i++) {
      const delay      = delays[illustList[i].getAttribute('data-illust')]
      const illustDivs = illustList[i].getElementsByTagName('div')
      for (let j = 0, jLength = illustDivs.length; j < jLength; j++) {
        illustDivs[j].style.animationDelay = (j * delay) + 'ms'
        illustDivs[j].style.transitionDelay = (j * delay) + 'ms'
        illustDivs[j].style['webkit-animation-delay'] = (j * delay) + 'ms'
        illustDivs[j].style['webkit-transition-delay'] = (j * delay) + 'ms'
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/common/Common.js